import React from "react";

import { SvgWrapper } from "../styles";

interface SvgComponentProps {
  height: number;
  width: number;
  color: string;
}

export const ChevronDown = (props: SvgComponentProps) => {
  const { width, height, color } = props;

  return (
    <SvgWrapper>
      <svg
        width={width}
        height={height}
        viewBox="0 0 20 20"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 14.0003C9.41668 14.0003 8.83335 13.7753 8.39168 13.3336L2.95835 7.90028C2.71668 7.65861 2.71668 7.25861 2.95835 7.01694C3.20002 6.77528 3.60002 6.77528 3.84168 7.01694L9.27502 12.4503C9.67502 12.8503 10.325 12.8503 10.725 12.4503L16.1583 7.01694C16.4 6.77528 16.8 6.77528 17.0417 7.01694C17.2833 7.25861 17.2833 7.65861 17.0417 7.90028L11.6083 13.3336C11.1667 13.7753 10.5833 14.0003 10 14.0003Z"
          fill={color}
        />
      </svg>
    </SvgWrapper>
  );
};
